module.exports = __webpack_public_path__ + "static/media/2.9326baa8.png";